<template lang="pug">
.contact(
  :style="{height: height}")
  b-header
  .container(
    ref="fullpage",
    v-fullpage="opts",
    @mousewheel.stop.prevent="mousewheel"
    @wheel.stop.prevent="mousewheel")
    .page(:style="{height: height}")
      .nav
        transition(name="left-in")
          .line(v-if="init")
        transition(name="right-in")
          .title(v-if="init") {{langs[lang].contact}}
      .content
        //- transition(name="scale")
        //-   a.item(v-if="init" href="https://m.weibo.cn/u/5663668317")
        //-     .icon.iconfont &#xe623;
        //-     .info
        //-       img(src="../assets/contact/weibo_qrcode.jpg")
        //-     .desc {{langs[lang].weibo}}
        //- transition(name="scale")
        //-   .item(v-if="init")
        //-     .icon.iconfont &#xe6ab;
        //-     .info
        //-       img(src="../assets/contact/weixin_qrcode.jpg")
        //-     .desc {{langs[lang].wechat}}
        //- transition(name="scale")
        //-   .item(v-if="init")
        //-     .icon.bp.iconfont &#xe606;
        //-     .info bp@bertelsmann.com
        //-     .desc {{langs[lang].bp}}
        //- transition(name="scale")
        //-   .item(v-if="init")
        //-     .icon.iconfont &#xe68a;
        //-     .info hr@bertelsmann.com
        //-     .desc {{langs[lang].joinus}}
        //- .icon-down(@click="next") &#xe608;
        transition(
          @enter="enter",
          @beforeEnter="beforeEnter")
          b-footer.footer(v-if="animateCtrl[0]")
      .copyright {{langs[lang].copyright}}
    //- .page(:style="{height: height}")
      //- .form
        transition(name="left-in")
          .title(v-show="animateCtrl[1]") {{langs[lang].subscribeNews}}
        .items
          transition(name="bottom-in")
            .item(v-show="animateCtrl[1]")
              label {{langs[lang].firstName}}
              input(name="first")
          transition(name="bottom-in")
            .item(v-show="animateCtrl[1]")
              label {{langs[lang].secondName}}
              input(name="last")
          transition(name="bottom-in")
            .item(v-show="animateCtrl[1]")
              label {{langs[lang].email}}
              input(name="email")
          .item.big
            .btn {{langs[lang].subscribe}}
</template>

<script>
import header from './header'
import footer from './footer'
import fanpage from '../mixin/fanpage.js'
const Contact = {
  mixins: [fanpage],
  props: [],
  data () {
    return {
      totalPage: 0,
      langs: {
        en: {
          contact: 'CONTACT US',
          weibo: 'WEIBO',
          wechat: 'WeChat Official Account',
          bp: 'BP',
          joinus: 'JOIN US',
          firstName: 'First name',
          secondName: 'Last name',
          email: 'E-mail Address',
          subscribeNews: 'Subscribe to get notifications about BAI events,news,and opportunities',
          subscribe: 'Subscribe',
          copyright: '©2019 Bertelsmann Asia Investments ALL RIGHTS RESERVED'
        },
        zh: {
          contact: '联系我们',
          weibo: '微博',
          wechat: '微信公众号',
          bp: '商业计划书',
          joinus: '加入我们',
          firstName: '名字',
          secondName: '姓氏',
          email: 'E-mail',
          subscribeNews: '订阅通知&新闻',
          subscribe: '订阅',
          copyright: '©2019 贝塔斯曼亚洲投资基金 ALL RIGHTS RESERVED'
        }
      }
    }
  },
  mounted () {
    this.animateCtrl[0] = true
  },
  components: {
    bHeader: header,
    bFooter: footer
  },
  computed: {
    lang () {
      return localStorage.lang
    }
  },
  methods: {
    beforeEnter: function (el) {
      window.Velocity.hook(el, 'translateX', '0%')
      window.Velocity.hook(el, 'translateY', '50px')
      window.Velocity.hook(el, 'opacity', 0)
    },
    next: function () {
      this.turnTo(++this.currentPage)
    },
    enter: function (el, done) {
      window.Velocity(
        el,
        {
          opacity: 1,
          translateY: 0
        },
        {
          duration: 500,
          delay: 300,
          complete: done
        }
      )
    }
  }
}
export default Contact
</script>

<style scoped lang="stylus">
@import '../common.styl'
.scale-enter-active, .scale-leave-active {
  transition: all 1s;
}
.scale-enter, .scale-leave-to {
  transform: scale(0);
  transform-origin: center;
  opacity: 0;
}
.icon-down {
  font-family: iconfont;
  position: absolute;
  bottom: 20px;
  right: 50%;
  font-size: 60px;
  transform: translateX(50%);
  cursor: pointer;
  transition: all 0.5s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  &:hover{
    bottom: 10px;
  }
}
.copyright{
  width: 100%;
  text-align: center;
  color: #666;
  font-size: 20px;
  margin-top: 100px;
}
@media (min-width: 720px) {
  .footer{
    bottom: 0;
    margin: 0 auto;
  }
  .content{
    display: flex;
    width: 1920px;
    margin: 90px auto 0;
    justify-content: space-around;
    .item{
      text-decoration: none;
      transition: all .5s;
      flex: 1 1 200px
      cursor: pointer;
      position: relative;
      top: 0;
      .line {
        width: 100%;
      }
      .info{
        opacity: 0
        transition: all .5s;
      }
      &:hover{
        top: -60px;
        .info{
          height: 100px;
          opacity: 1;
        }
      }
      .icon{
        margin: 0 auto;
        font-size: 80px;
        color: #002b69;
        width: 180px;
        height: 180px;
        border-radius: 50%;
        border: 2px solid #b3b3b3;
        text-align: center;
        line-height: 180px;
        position: relative;
        &.bp{
          font-size: 60px;
        }
      }
      .info{
        position: relative;
        height: 0;
        text-align: center;
        font-size: 22px;
        margin-top: 20px;
        line-height: 100px;
        img{
          width: 100px;
          height: 100px;
        }
      }
      .desc{
        color: #808080;
        font-size: 22px;
        text-align: center;
        margin-top: 20px;
        position: relative;
      }
    }
  }
  .form{
    width: 1080px;
    height: 420px;
    background: #e5e5e5;
    margin-top: 200px;
    margin: 200px auto 0;
    padding: 50px 100px;
    .title{
      font-size: 24px;
      color: #767676;
      text-align: center;
      font-weight: bold;
    }
    .items{
      width: 100%;
      .item{
        text-decoration: none;
        margin-top: 50px;
        width: 33%;
        height: 50px;
        float: left;
        label{
          font-size: 14px;/*no*/
          margin-bottom: 5px;
          display: block;
          position: relative;
          left: 44px;
        }
        input{
          display: block;
          margin: 0 auto;
          width: 210px;
          height: 41px;
        }
        .bp{
          font-size: 60px;
        }
        &.big{
          width: 100%;
          text-align: center;
        }
        .btn{
          display: inline-block;
          background: url("../assets/bg_blue.png") center / cover;
          color: #fff;
          width: 160px;
          height: 52px;
          line-height: 52px;
          padding-left: 5px;
          font-size: 16px;/*no*/
          font-weight: bold;
          position: relative;
          cursor: pointer;
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .content{
    display: flex;
    flex-wrap: wrap;
    padding: 50px 100px;
    margin: 50px auto;
    justify-content: space-around;
    .item{
      text-decoration: none;
      transition: all 1s;
      flex: 1 1 600px
      cursor: pointer;
      &:hover{
        position: relative;
        top: -60px;
        .icon{
        }
        .info{
          display: block;
        }
        .desc{
          display: none;
        }
      }
      .icon{
        margin: 0 auto;
        font-size: 100px;/*no*/
        color: #002b69;
        margin-top: 150px;
        width: 600px;
        height: 600px;
        border-radius: 50%;
        border: 2px solid #b3b3b3;
        text-align: center;
        line-height: 600px;
        font-size: 300px;/*no*/
        position: relative;
        &.bp{
          font-size: 150px;/*no*/
        }
      }
      .info{
        position: relative;
        display: none;
        text-align: center;
        height: 100px;
        font-size: 14px;/*no*/
        margin-top: 20px;
        line-height: 100px;
        img{
          width: 300px;
          height: 300px;
        }
      }
      .desc{
        color: #808080;
        font-size: 14px;/*no*/
        text-align: center;
        margin-top: 20px;
        position: relative;
      }
    }
  }
  .form{
    width: 1920px;
    height: 1080px;
    margin: 200px auto 0;
    margin-top: 400px;
    .title{
      font-size: 14px;/*no*/
      color: #767676;
      font-weight: bold;
      margin-left: 120px;
      margin-bottom: 50px;
    }
    .items{
      width: 100%;
      height: 1800px;
      padding: 120px;
      background: #e7e7e7;
      .item{
        text-decoration: none;
        margin-top: 50px;
        margin-bottom: 200px;
        width: 100%;
        label{
          font-size: 14px;/*no*/
          margin-bottom: 5px;
          display: block;
          color: #393939;
          position: relative;
        }
        input{
          display: block;
          margin-top: 50px;
          width: 1000px;
          height: 200px;
        }
        &.big{
          width: 100%;
          text-align: center;
        }
        .btn{
          margin-top: 100px;
          display: inline-block;
          background: url("../assets/bg_blue.png") center / cover;
          color: #e8e8e8;
          width: 768px;
          height: 249.6px;
          line-height: 249.6px;
          padding-left: 5px;
          font-size: 16px;/*no*/
          position: relative;
          cursor: pointer;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// contact.vue?9e389150